import { useEffect } from 'react';
import { Entity } from '@backstage/catalog-model';
import { useEntityList, EntityFilter } from '@backstage/plugin-catalog-react';

export class ExcludeLifecycleFilter implements EntityFilter {
  private readonly excludedValues: string[];

  constructor(excludedValues: string[]) {
    this.excludedValues = excludedValues;
  }

  filterEntity(entity: Entity): boolean {
    const lifecycle = (entity.spec as Record<string, unknown>)?.lifecycle as
      | string
      | undefined;
    if (!lifecycle) return true;
    return !this.excludedValues.includes(lifecycle);
  }
}

/**
 * Invisible filter component that automatically excludes entities
 * with the specified lifecycle values from the entity list.
 * Place inside an EntityListProvider to activate.
 */
export function ExcludeRetiredFilter() {
  const { updateFilters } = useEntityList();

  useEffect(() => {
    (updateFilters as (filters: Record<string, EntityFilter>) => void)({
      lifecycleExclude: new ExcludeLifecycleFilter(['retired']),
    });
  }, [updateFilters]);

  return null;
}
